import React from 'react';
import { COLORS } from '../../styles/tokens';

const fmt = n => Number(n).toLocaleString('nb-NO');

function claimTitle(c) {
  if (c.kind === 'waiting') {
    const where = c.stage === 'delivery' ? 'levering' : 'henting';
    return `Ventetid ved ${where} (${fmt(c.minutes ?? 0)} min)`;
  }
  if (c.kind === 'bomtur') return 'Bomtur';
  if (c.kind === 'overtime') return `Overtid (${fmt(c.minutes ?? 0)} min)`;
  if (c.kind === 'cancellation') return 'Avbestillingsgebyr';
  return 'Krav';
}

function statusLabel(c, mode) {
  switch (c.status) {
    case 'available': return 'Kan kreves av sjåføren';
    case 'pending': return mode === 'admin' ? 'Venter på bestiller' : 'Venter på deg';
    case 'approved': return 'Godkjent';
    case 'disputed': return 'Bestridt';
    case 'rejected': return 'Avvist';
    default: return c.status;
  }
}

// Krav fra sjåføren på et oppdrag. mode="orderer": Godkjenn/Bestrid. mode="admin": Godkjenn/Avvis.
export default function ClaimsList({ order, onDecide, busyId = null, error = '', mode = 'orderer' }) {
  const claims = order?.claims ?? [];
  if (claims.length === 0) return null;
  const isInvoice = order.paymentMethod === 'invoice';
  const admin = mode === 'admin';
  // Ordren er avsluttet: bestiller kan ikke lenger avgjøre krav (serveren avviser det)
  const closed = !admin && ['completed', 'invoiced'].includes(order.status);

  return (
    <div style={styles.box}>
      <h2 style={styles.h2}>Krav</h2>
      <ul style={styles.list}>
        {claims.map(c => {
          const canDecide = admin ? ['pending', 'disputed'].includes(c.status) : c.status === 'pending' && !closed;
          const tippi = c.kind === 'cancellation' || (c.status === 'approved' && !isInvoice);
          const disabled = busyId === c.id;
          return (
            <li key={c.id} style={styles.item}>
              <div style={styles.top}>
                <span style={styles.title}>{claimTitle(c)}</span>
                <b style={styles.amount}>{fmt(c.amount ?? 0)} kr</b>
              </div>
              {c.note && <div style={styles.note}>{c.note}</div>}
              <div style={styles.status}>{statusLabel(c, mode)}</div>
              {tippi && <div style={styles.note}>Håndteres av Tippi</div>}
              {closed && c.status === 'pending' && <div style={styles.note}>Ordren er avsluttet. Kontakt Tippi om kravet.</div>}
              {canDecide && (
                <div style={styles.actions}>
                  <button type="button" style={styles.primary} disabled={disabled} onClick={() => onDecide(c.id, 'approve')}>Godkjenn</button>
                  <button type="button" style={styles.secondary} disabled={disabled} onClick={() => onDecide(c.id, admin ? 'reject' : 'dispute')}>
                    {admin ? 'Avvis' : 'Bestrid'}
                  </button>
                </div>
              )}
            </li>
          );
        })}
      </ul>
      {error && <p role="alert" style={styles.error}>{error}</p>}
    </div>
  );
}

const styles = {
  box:       { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 16, padding: '14px 16px', marginTop: 14 },
  h2:        { fontSize: 18, fontWeight: 700, margin: '0 0 6px', color: COLORS.textDark },
  list:      { listStyle: 'none', margin: 0, padding: 0 },
  item:      { padding: '10px 0', borderTop: `1px solid ${COLORS.border}` },
  top:       { display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 14, color: COLORS.textDark },
  title:     { fontWeight: 600 },
  amount:    { whiteSpace: 'nowrap' },
  note:      { fontSize: 13, color: COLORS.textMid, marginTop: 2 },
  status:    { fontSize: 12.5, fontWeight: 700, color: COLORS.textMid, marginTop: 2 },
  actions:   { display: 'flex', gap: 8, marginTop: 8 },
  primary:   { height: 38, borderRadius: 19, border: 'none', background: COLORS.accent, color: '#1a1a2e', fontWeight: 700, fontSize: 13.5, cursor: 'pointer', padding: '0 16px' },
  secondary: { height: 38, borderRadius: 19, border: `1px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark, fontWeight: 600, fontSize: 13.5, cursor: 'pointer', padding: '0 16px' },
  error:     { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '10px 12px', borderRadius: 10, fontSize: 14, margin: '8px 0 0' },
};
